import React, { useEffect } from "react"

const sendEmailNotification = ({ subject, html }) => {
  return fetch(`https://mktg-api.unzer.com/api/3dsecure-email-notification`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ subject, html }),
  })
}

const MsDynamicsForm = ({
  formId,
  elementId,
  onAfterFormLoad,
  onAfterFormSubmit,
  emailNotification,
}) => {
  useEffect(() => {
    const formScript = document.createElement("script")
    formScript.src =
      "https://cxppusa1formui01cdnsa01-endpoint.azureedge.net/eur/FormLoader/FormLoader.bundle.js"
    formScript.async = true
    document.body.appendChild(formScript)

    const handleAfterFormLoad = event => {
      if (onAfterFormLoad) {
        onAfterFormLoad(event)
      }
    }

    const handleAfterFormSubmit = event => {
      const { successful, Success, payload, Payload } = event.detail || {}
      const isSuccessful = successful ?? Success

      if (isSuccessful && emailNotification) {
        sendEmailNotification(emailNotification).catch(() => {})
      }

      if (onAfterFormSubmit) {
        onAfterFormSubmit({
          successful: isSuccessful,
          payload: payload ?? Payload,
          event,
        })
      }
    }

    document.addEventListener("d365mkt-afterformload", handleAfterFormLoad)
    document.addEventListener("d365mkt-afterformsubmit", handleAfterFormSubmit)

    return () => {
      document.removeEventListener("d365mkt-afterformload", handleAfterFormLoad)
      document.removeEventListener(
        "d365mkt-afterformsubmit",
        handleAfterFormSubmit
      )

      if (document.body.contains(formScript)) {
        document.body.removeChild(formScript)
      }
    }
  }, [onAfterFormLoad, onAfterFormSubmit, emailNotification])

  return (
    <div className="form_ms-dynamics">
      <div
        id={elementId}
        data-form-id={formId}
        data-form-api-url="https://public-eur.mkt.dynamics.com/api/v1.0/orgs/f489bf7c-4f35-496f-bd64-ac85db9de989/landingpageforms"
        data-cached-form-url={`https://assets-eur.mkt.dynamics.com/f489bf7c-4f35-496f-bd64-ac85db9de989/digitalassets/forms/${formId}`}
      ></div>
    </div>
  )
}

export default MsDynamicsForm
